import type { AxiosResponse } from "axios";
import { BASE_URL, httpClient } from "../config/develop-config";

const baseUrl = `${BASE_URL}/crm/tier-transaction`;

/**
 * One row of a shop's accrual history. The backend returns raw ledger rows and the shape
 * depends on the company: ICPL reads tier_invoice_transaction (baht, with action/status),
 * the others read tier_shipment (tonnes, no baht). Both carry createdAt and orderNo.
 */
export interface TierTransactionItem {
  createdAt: string;
  orderNo: string | null;
  // ICPL (invoice ledger)
  tierInvoiceTransactionId?: string;
  invoiceNo?: string | null;
  status?: "APPROVE" | "CN" | "DN" | "CANCEL";
  action?: "INCREASE" | "DECREASE";
  actionName?: string | null;
  amount?: number;
  // ICPF / ICPI (shipment ledger)
  tierShipmentId?: string;
  pdoNo?: string | null;
  sumQuantity?: number;
  isCanceled?: boolean;
}

const getTierTransaction = async (params: {
  customerCompanyId: number;
  company: string;
  tierProgramId?: string;
  startDate?: string;
  endDate?: string;
  page: number;
  take: number;
}) => {
  return await httpClient
    .get(baseUrl, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

export { getTierTransaction };
